import getAllMemberSubmissionList from "./getAllMemberSubmissionList";
import deleteMemberSubmissionById from "./deleteMemberSubmissionById";

const memberSubmissionAdminServices = {
  getAllMemberSubmissionList,
  deleteMemberSubmissionById,
};

export default memberSubmissionAdminServices;
